export const OP_EQUALS = "EQUALS";
export const OP_CONTAINS = "CONTAIN";

export const ALL_OPERATIONS = [OP_CONTAINS, OP_EQUALS];